<template>
  <b-nav-item>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      class="content-button"
      @click="ingreso"
    >
      <feather-icon
        icon="LogInIcon"
        size="16"
      />
      <transition name="fade">
        <span
          class="align-middle ml-50"
        >
          Ingresar
        </span>
      </transition>
    </b-button>
  </b-nav-item>
</template>

<script>
import { BNavItem, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import hostname from '@core/utils/http/config-hostname'

export default {
  components: {
    BNavItem,
    BButton,
  },
  directives: {
    Ripple,
  },
  setup() {
    const ingreso = () => {
      window.location.href = `${hostname().host}/${process.env.VUE_APP_SERVICE_INGRESO}`
    }

    return { ingreso }
  },
}
</script>

<style lang="scss" scoped>
.content-button {
  padding: 0.5rem 0.8rem;
  margin: 0.27rem 0;
}
</style>
